import { Table, TableContainer } from "@mui/material";
import useTable from "src/hooks/useTable";

import useGetEntities from "../../EntitiesStatus/useGetEntities";
import ContextTable from "./contextTable";
import TableBody from "./TableBody";
import TableHeader from "./TableHeader";

// ----------------------------------------------------------------------

export const EntitiesOptionsTable = () => {
	const { entities } = useGetEntities();

	const control = useTable({
		defaultOrderBy: "name",
		defaultRowsPerPage: 10,
		defaultDense: true
	});

	return (
		<ContextTable.Provider value={{ ...control }}>
			<TableContainer sx={{ height: 540 }}>
				{entities && (
					<Table size='small'>
						<TableHeader />
						<TableBody data={entities} />
					</Table>
				)}
			</TableContainer>
		</ContextTable.Provider>
	);
};

export default EntitiesOptionsTable;
